<template>
  <div class="page page-password-reset">
    <a href="/" class="logo">
      <img :src="assetPath('logo.svg')" :alt="appName" />
    </a>
    <FormPasswordReset />
  </div>
</template>

<script setup>
  import FormPasswordReset from '@/components/forms/FormPasswordReset.vue'
  import { assetPath } from '@/util'

  const appName = import.meta.env.VITE_APP_NAME
</script>
